/**
 * ## Report list component
 *
 * @module src/components/reportlist
*/

'use strict';

const destroy = () => {
    $('#component_catch').css('display', 'none');
};

/**
 * Report list display.
 */
const create = (options, data, callback) => {
    let drophtml = '';
    let dropcount = 0;
    data.forEach((row) => {
        if (options.highlight === row.value || options.highlight === row.description) {
            drophtml += `<div class="reportlistitem theme_bg_carbon" \
                        id="bl${++dropcount}${options.target_id}" \
                        data-value="${row.value}" data-description="${row.description}">\
                        <i class="fa fa-check"></i> ${row.description}</div>`;
        } else {
            drophtml += `<div class="reportlistitem" id="bl${++dropcount}${options.target_id}" \
                        data-value="${row.value}" data-description="${row.description}">\
                        ${row.description}</div>`;
        }
    });
    drophtml += '<div class="buttonlistend"></div>';
    $(`#${options.target_id}`).html(drophtml);
    $('.reportlistitem').off();
    $('.reportlistitem').fastClick((e) => {
        e.stopPropagation();
        destroy();
        const returned = {
            value: $(`#${e.target.id}`).data('value'),
            description: $(`#${e.target.id}`).data('description'),
        };
        callback(null, returned);
    });
};

module.exports = {
    create,
    destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/reportlist/index.js
 **/